import { createContext, useContext } from 'react';
import { AutocompleteController } from './store/AutocompleteController';

export const AutocompleteContext = createContext<AutocompleteController | null>(
  null,
);

export function useAutocompleteContext() {
  const context = useContext(AutocompleteContext);

  if (!context) throw new Error('There is no AutocompleteContext');

  return context;
}
